import angular from 'angular';
import templateDetailComponent from './template-detail.component';
import TemplateDetailService from './template-detail.service';
import templateDetailConfig from './template-detail.config';

let templateDetailModule = angular.module('app.templates.templateDetail',[])
  .component('templateDetail', templateDetailComponent)
  .service('TemplateDetailService', TemplateDetailService)
  .config(templateDetailConfig);

export default templateDetailModule;



/** WEBPACK FOOTER **
 ** ./www/components/templates/template-detail/template-detail.js
 **/